export class KeyValue {
	public Key: string;
	public Value: string;
}